import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphMedium } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  padding: 32px 0;

  @media ${from(Device.Tablet)} {
    padding: 32px;
  }
`;
const List = styled.ul ``;
const Item = styled.li `
  display: grid;
  gap: 16px;
  grid-template-columns: auto 1fr auto;

  &:not(:last-child) {
    border-bottom: 1px solid ${rgba(brand.greyDark, 0.5)};
    margin-bottom: 24px;
    padding-bottom: 24px;
  }

  @media ${from(Device.TabletLarge)} {
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const ItemCircle = styled.span `
  display: flex;
  border-radius: 50%;
  background: ${brand.greyDark};
  color: ${brand.white};
  ${fonts.brandonGrotesque.bold}
  font-size: 18px;
  line-height: 1em;
  height: 35px;
  place-content: center;
  place-items: center;
  text-align: center;
  width: 35px;
`;
const ItemContent = styled.div ``;
const ItemTitle = styled.h3 `
  ${paragraphMedium}
  ${fonts.brandonGrotesque.bold}
  margin-bottom: 8px;
`;
const ItemAddress = styled.address `
  ${paragraphMedium}
  margin-bottom: 8px;
`;
const ItemCta = styled.button `
  background: none;
  border: 0;
  ${fonts.brandonGrotesque.bold}
  font-size: 20px;
  margin: 0;
  padding: 0;
  text-underline-position: under;

  svg {
    display: inline-block;
    height: 12px;
    margin-left: 8px;
    width: 10px;
  }

  &.focus-ring,
  &:hover {
    text-decoration: underline;
  }
`;
const ItemDistance = styled.span `
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const ItemDistanceIcon = styled.span `
  display: block;
  height: 40px;
  width: 40px;
`;
const ListAreaStyles = {
    Container,
    Item,
    ItemAddress,
    ItemCircle,
    ItemContent,
    ItemCta,
    ItemDistance,
    ItemDistanceIcon,
    ItemTitle,
    List,
};
export default ListAreaStyles;
